import React from "react";
import { Link } from "react-router-dom";
import { MdOutlineCode } from "react-icons/md";
import { MdOutlineCodeOff } from "react-icons/md";
import { FaFacebook } from "react-icons/fa6";
import { FaLinkedin } from "react-icons/fa";
import { FaDiscord } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
import { AnimatePresence, motion } from "framer-motion";
import useTheme from "../../hooks/useTheme";

// components
import ThemeToggler from "./ThemeToggler";

const socialLinks = [
	{
		id: 1,
		title: "Facebook",
		icon: <FaFacebook />,
		url: "http://facebook.com",
	},
	{
		id: 2,
		title: "LinkedIn",
		icon: <FaLinkedin />,
		url: "http://linkedin.com",
	},
	{ id: 3, title: "Discord", icon: <FaDiscord />, url: "http://discord.com" },
	{
		id: 4,
		title: "Instagram",
		icon: <FaInstagram />,
		url: "http://instagram.com",
	},
];

const socialMenu = socialLinks.map((socialLink) => (
	<Link
		key={socialLink.id}
		to={socialLink.url}
		target="_blank"
		className="text-green-800 hover:text-green-600">
		{socialLink.icon}
	</Link>
));

const openBtnVariants = {
	tap: {
		scale: 0.5,
	},
};

const socialMenuRowVariants = {
	intial: {
		width: 0,
		opacity: 0,
	},
	animate: {
		width: "8em",
		opacity: 1,
	},
	exit: {
		width: 0,
		opacity: 0,
	},
	transition: {
		duration: 0.5,
		ease: "easeInOut",
	},
};

const socialMenuColVariants = {
	intial: {
		height: 0,
		opacity: 0,
	},
	animate: {
		height: "8em",
		opacity: 1,
	},
	exit: {
		height: 0,
		opacity: 0,
	},
	transition: {
		duration: 0.5,
		ease: "easeInOut",
	},
};

const SocialMediaLinks = () => {
	const { theme, open, setOpen } = useTheme();

	return (
		<div
			className={`fixed bottom-5 right-5 z-10 flex flex-row gap-2 ${
				theme === "dark" ? "shadow-stone-300" : "shadow-stone-800"
			} shadow-inner rounded-2xl p-1`}>
			<ThemeToggler />
			<motion.button
				variants={openBtnVariants}
				whileTap="tap"
				className={`p-2 text-3xl rounded-2xl hover:text-green-800`}
				onClick={() => setOpen((prev) => !prev)}>
				{open ? <MdOutlineCodeOff /> : <MdOutlineCode />}
			</motion.button>
			<AnimatePresence>
				{open && (
					<motion.div
						variants={socialMenuRowVariants}
						initial="initial"
						animate="animate"
						exit="exit"
						transition="transition"
						className="flex flex-row lg:gap-2 items-center justify-evenly overflow-hidden text-3xl">
						{socialMenu}
					</motion.div>
				)}
			</AnimatePresence>
		</div>
	);
};

export default SocialMediaLinks;
